// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 697) return "news.1.2.0.bundle.css";
	// return url for filenames based on template
	return "" + ({"95":"pajination","174":"alertBs","213":"textContent","275":"ctaSection","849":"serviceBoxes","956":"scrollToTop"}[chunkId] || chunkId) + "." + {"95":"00ddf087e913b45ff8ce","174":"184c498dc05eb3795c2a","213":"d747df061d2a8afe93aa","275":"ec745621a74d828805b6","849":"dea1e7bbddca55f7cdf4","956":"0c2aece0ac55a1266249","968":"7cfb22c9a2528d01a95c"}[chunkId] + ".css";
};